import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  Schema,
  SchemaListRequest,
  SchemaListResponse,
  SchemaCreateRequest,
  SchemaUpdateRequest,
  SchemaOptionListRequest,
  SchemaOptionListResponse,
} from "./types";

export const schemaListService = (params: SchemaListRequest) =>
  RestAPIClient.call<SchemaListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      params,
      requireAuthentication: true,
    },
  });

export const schemaOptionListService = (params: SchemaOptionListRequest) =>
  RestAPIClient.call<SchemaOptionListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.OptionList,
    config: {
      params,
      requireAuthentication: true,
    },
  });

export const schemaDetailService = (id: number) =>
  RestAPIClient.call<Schema>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const schemaCreateService = (params: SchemaCreateRequest) =>
  RestAPIClient.call<Schema>({
    method: HTTPRequestMethods.POST,
    data: params,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
  });

export const schemaUpdateService = ({
  id,
  ...innerPayload
}: SchemaUpdateRequest) =>
  RestAPIClient.call<Schema>({
    method: HTTPRequestMethods.PUT,
    data: innerPayload,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const schemaDeleteService = (id: number) =>
  RestAPIClient.call<Schema>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Delete}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
